module.exports = __webpack_public_path__ + "img/2026-09_academic-excellence.fd3198ec.webp";